module.exports = __webpack_public_path__ + "static/media/signal-alt.2f2e20fc.svg";